import { Link } from "react-router-dom";
import DropListForm from "@/components/DropListForm";
import VoidAtmosphere from "@/components/VoidAtmosphere";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#2a1a3a] mt-32 bg-[#05000f] relative overflow-hidden"
    >
      <VoidAtmosphere intensity="footer" />
      <div className="hairline-grid absolute inset-0 opacity-25 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 relative">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="inline-flex items-center gap-3">
              <img
                src="/brand/emblem.png"
                alt="FEMBOT NEX emblem"
                width={40}
                height={40}
                className="shrink-0 drop-shadow-[0_0_18px_rgba(255,20,147,0.6)]"
                draggable={false}
              />
              <div className="flex flex-col leading-none">
                <div className="font-display text-3xl md:text-4xl tracking-tight">
                  FEMBOT<span className="text-[#ff1493]">·</span>NEX
                </div>
                <div className="mt-2 font-mono text-[10px] tracking-[0.35em] uppercase text-[#c084fc]">
                  POST HOMINEM
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-[#b4a3c7] max-w-md leading-relaxed">
              Post-ironic activewear for emotional system failure. Limited drops only. US-based. Prices in USD.
            </p>
            <div className="mt-6 font-mono text-[11px] tracking-[0.2em] uppercase text-[#7a6a90] space-y-1">
              <div>NODE // fembotnex.com</div>
              <div>ENCRYPTED // TLS_1.3</div>
              <div>ARTIFACT_01 / SS26</div>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#ff1493] mb-4">
              // Navigate
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                ["/shop", "Shop"],
                ["/drop-001", "Drop 001"],
                ["/contraband", "Contraband"],
                ["/about", "About"],
                ["/sizing", "Sizing"],
                ["/shipping-returns", "Shipping / Returns"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase().replace(/[\s/]+/g, "-")}`}
                    className="text-[#b4a3c7] hover:text-white transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#ff1493] mb-4">
              // Authorize Uplink
            </h4>
            <p className="text-sm text-[#b4a3c7] mb-4">
              Preorder access, restock notifications, contraband transmissions.
            </p>
            <DropListForm source="footer_drop_list" testIdPrefix="footer-drop" />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#1a0a2a] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[10px] tracking-[0.2em] uppercase text-[#7a6a90]">
          <div>© {new Date().getFullYear()} FEMBOT NEX · Post Hominem · Made in the void</div>
          <div className="flex items-center gap-4">
            <span>Final sale on contraband · No restocks</span>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="hover:text-white transition-colors"
            >
              Admin Access →
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
